import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useIsAuthenticated, useAuthStore } from '../auth/store';

/** Redirige vers /login si aucune session ; vérifie aussi qu'une organisation est active. */
export function RequireAuth() {
  const authed = useIsAuthenticated();
  const orgId = useAuthStore((s) => s.orgId);
  const location = useLocation();
  if (!authed) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (!orgId) return <Navigate to="/select-org" replace />;
  return <Outlet />;
}
